module.exports = __webpack_public_path__ + "assets/webgl/stickers_basecolor.666ba0ce.jpg";